module.exports = __webpack_public_path__ + "pikachu.gif";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-types/assets/pikachu.gif
// module id = 1118
// module chunks = 10